module.exports = __webpack_public_path__ + "img/buycoin-03.0390918f.svg";